module.exports = __webpack_public_path__ + "static/media/Montserrat-BoldItalic.1b384149.ttf";